import React from 'react';
import {PhoneInput, defaultCountries, parseCountry} from 'react-international-phone';
import {bindField} from 'utils/input-utils';
import {Title, Error} from 'styles/styled-components/field-styled-components';
import {observer} from 'mobx-react';
import {PhoneFieldWrapper} from './styles';

const countries = defaultCountries.filter(country => {
  const {iso2} = parseCountry(country);
  return ![
    'BS',
    'BY',
    'BR',
    'KY',
    'CN',
    'DO',
    'EC',
    'EG',
    'SV',
    'GU',
    'GT',
    'JO',
    'LR',
    'MY',
    'MH',
    'FM',
    'MC',
    'MZ',
    'NZ',
    'NI',
    'PY',
    'PE',
    'PH',
    'QA',
    'CG',
    'KN',
    'LC',
    'WS',
    'SA',
    'SG',
    'KR',
    'LK',
    'TW',
    'TH',
    'TR',
    'TM',
    'UY',
    'VE',
    'VN',
    'VI',
    'IN',
    'KW',
    'PR'
  ].includes(iso2.toUpperCase());
});

function PhoneField({title, form, field, hideError, placeholder}) {
  const boundField = bindField(form, field);
  return (
    <PhoneFieldWrapper>
      <Title>{title}</Title>
      <PhoneInput
        placeholder={placeholder}
        defaultCountry="us"
        preferredCountries={['us', 'ca', 'mx']}
        countries={countries}
        {...boundField}
        onChange={phone => form.$(field).sync(phone)}
      />
      {!hideError && <Error visible={true}>{boundField.error}</Error>}
    </PhoneFieldWrapper>
  );
}

export default observer(PhoneField);
